import React from 'react';

import { SPACE_OVERVIEW } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { getSpaceOverviewRoute } from '@confluence/ssr-app/entry-points/routes.ts';

/**
 * Keeping the redirection because refined themes only support space overview route.
 * https://atlassian.slack.com/archives/CFGSEJDFT/p1721136254384829
 */
export const SpaceIndexRoute = getSpaceOverviewRoute(({ spaceKey, query }) => (
	<Redirection name={SPACE_OVERVIEW.name} params={{ spaceKey, query }} />
));
